/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DataPageOfSecurityQuestions } from '../models/data-page-of-security-questions';
import { securityQuestionDelete } from '../fn/security-question/security-question-delete';
import { SecurityQuestionDelete$Params } from '../fn/security-question/security-question-delete';
import { securityQuestionGet } from '../fn/security-question/security-question-get';
import { SecurityQuestionGet$Params } from '../fn/security-question/security-question-get';
import { securityQuestionGet2 } from '../fn/security-question/security-question-get-2';
import { SecurityQuestionGet2$Params } from '../fn/security-question/security-question-get-2';
import { securityQuestionGetAll } from '../fn/security-question/security-question-get-all';
import { SecurityQuestionGetAll$Params } from '../fn/security-question/security-question-get-all';
import { securityQuestionGetSecurityQuestion } from '../fn/security-question/security-question-get-security-question';
import { SecurityQuestionGetSecurityQuestion$Params } from '../fn/security-question/security-question-get-security-question';
import { securityQuestionGetSecurityQuestion2 } from '../fn/security-question/security-question-get-security-question-2';
import { SecurityQuestionGetSecurityQuestion2$Params } from '../fn/security-question/security-question-get-security-question-2';
import { securityQuestionPost } from '../fn/security-question/security-question-post';
import { SecurityQuestionPost$Params } from '../fn/security-question/security-question-post';
import { securityQuestionPut } from '../fn/security-question/security-question-put';
import { SecurityQuestionPut$Params } from '../fn/security-question/security-question-put';
import { SecurityQuestions } from '../models/security-questions';

@Injectable({ providedIn: 'root' })
export class SecurityQuestionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `securityQuestionGet()` */
  static readonly SecurityQuestionGetPath = '/api/SecurityQuestion';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `securityQuestionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  securityQuestionGet$Response(params?: SecurityQuestionGet$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfSecurityQuestions>> {
    return securityQuestionGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `securityQuestionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  securityQuestionGet(params?: SecurityQuestionGet$Params, context?: HttpContext): Observable<DataPageOfSecurityQuestions> {
    return this.securityQuestionGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfSecurityQuestions>): DataPageOfSecurityQuestions => r.body)
    );
  }

  /** Path part for operation `securityQuestionPost()` */
  static readonly SecurityQuestionPostPath = '/api/SecurityQuestion';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `securityQuestionPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  securityQuestionPost$Response(params: SecurityQuestionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return securityQuestionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `securityQuestionPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  securityQuestionPost(params: SecurityQuestionPost$Params, context?: HttpContext): Observable<Blob> {
    return this.securityQuestionPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `securityQuestionGetAll()` */
  static readonly SecurityQuestionGetAllPath = '/securityQuestions/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `securityQuestionGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  securityQuestionGetAll$Response(params?: SecurityQuestionGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfSecurityQuestions>> {
    return securityQuestionGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `securityQuestionGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  securityQuestionGetAll(params?: SecurityQuestionGetAll$Params, context?: HttpContext): Observable<DataPageOfSecurityQuestions> {
    return this.securityQuestionGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfSecurityQuestions>): DataPageOfSecurityQuestions => r.body)
    );
  }

  /** Path part for operation `securityQuestionGet2()` */
  static readonly SecurityQuestionGet2Path = '/api/SecurityQuestion/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `securityQuestionGet2()` instead.
   *
   * This method doesn't expect any request body.
   */
  securityQuestionGet2$Response(params: SecurityQuestionGet2$Params, context?: HttpContext): Observable<StrictHttpResponse<SecurityQuestions>> {
    return securityQuestionGet2(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `securityQuestionGet2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  securityQuestionGet2(params: SecurityQuestionGet2$Params, context?: HttpContext): Observable<SecurityQuestions> {
    return this.securityQuestionGet2$Response(params, context).pipe(
      map((r: StrictHttpResponse<SecurityQuestions>): SecurityQuestions => r.body)
    );
  }

  /** Path part for operation `securityQuestionPut()` */
  static readonly SecurityQuestionPutPath = '/api/SecurityQuestion/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `securityQuestionPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  securityQuestionPut$Response(params: SecurityQuestionPut$Params, context?: HttpContext): Observable<StrictHttpResponse<SecurityQuestions>> {
    return securityQuestionPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `securityQuestionPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  securityQuestionPut(params: SecurityQuestionPut$Params, context?: HttpContext): Observable<SecurityQuestions> {
    return this.securityQuestionPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<SecurityQuestions>): SecurityQuestions => r.body)
    );
  }

  /** Path part for operation `securityQuestionDelete()` */
  static readonly SecurityQuestionDeletePath = '/api/SecurityQuestion/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `securityQuestionDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  securityQuestionDelete$Response(params: SecurityQuestionDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return securityQuestionDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `securityQuestionDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  securityQuestionDelete(params: SecurityQuestionDelete$Params, context?: HttpContext): Observable<Blob> {
    return this.securityQuestionDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `securityQuestionGetSecurityQuestion()` */
  static readonly SecurityQuestionGetSecurityQuestionPath = '/forgot/questionlist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `securityQuestionGetSecurityQuestion()` instead.
   *
   * This method doesn't expect any request body.
   */
  securityQuestionGetSecurityQuestion$Response(params?: SecurityQuestionGetSecurityQuestion$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfSecurityQuestions>> {
    return securityQuestionGetSecurityQuestion(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `securityQuestionGetSecurityQuestion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  securityQuestionGetSecurityQuestion(params?: SecurityQuestionGetSecurityQuestion$Params, context?: HttpContext): Observable<DataPageOfSecurityQuestions> {
    return this.securityQuestionGetSecurityQuestion$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfSecurityQuestions>): DataPageOfSecurityQuestions => r.body)
    );
  }

  /** Path part for operation `securityQuestionGetSecurityQuestion2()` */
  static readonly SecurityQuestionGetSecurityQuestion2Path = '/api/SecurityQuestion/{uName}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `securityQuestionGetSecurityQuestion2()` instead.
   *
   * This method doesn't expect any request body.
   */
  securityQuestionGetSecurityQuestion2$Response(params: SecurityQuestionGetSecurityQuestion2$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfSecurityQuestions>> {
    return securityQuestionGetSecurityQuestion2(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `securityQuestionGetSecurityQuestion2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  securityQuestionGetSecurityQuestion2(params: SecurityQuestionGetSecurityQuestion2$Params, context?: HttpContext): Observable<DataPageOfSecurityQuestions> {
    return this.securityQuestionGetSecurityQuestion2$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfSecurityQuestions>): DataPageOfSecurityQuestions => r.body)
    );
  }

}
